import * as React from 'react';
import { useState } from 'react';
import styled from "styled-components";
import { Select } from "@arco-design/web-react";
import AddDropdownFooter from "../../Components/AddDropdownFooter";

const Option = Select.Option;

// Single-select contact-list picker for a broadcast's audience. When an onAddNew
// callback is provided, a "New list" action is pinned to the bottom of the
// dropdown (the popup is controlled so it closes before the create dialog opens).
const FormControl = styled.div`
  padding-bottom: 10px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const FieldLabel = styled.div`
  font-size: 12px;
  color: var(--color-text-3);
  margin-bottom: 4px;
`;

function ContactListDropdown({ allContactListItems, contactListFilterId, handleContactListIdChange, disabled, onAddNew }) {
  const label = "Select Contact List";
  const [open, setOpen] = useState(false);

  return (
    <FormControl>
      <FieldLabel>{label} </FieldLabel>
      <Select
        value={contactListFilterId}
        onChange={(value) => handleContactListIdChange({ target: { value } })}
        disabled={disabled}
        {...(onAddNew
          ? {
              popupVisible: open,
              onVisibleChange: setOpen,
              dropdownRender: (menu) => (
                <div>
                  {menu}
                  <AddDropdownFooter label="New list" onClick={() => { setOpen(false); onAddNew(); }} />
                </div>
              ),
            }
          : {})}
      >
        <Option value="all">All</Option>
        {
          allContactListItems.map((item) => {
            return (
              <Option key={item.id} value={item.id}>{item.name}</Option>
            )
          })
        }
        <Option value="None">None</Option>
      </Select>
    </FormControl>
  );
}


export default ContactListDropdown;
